module.exports = __webpack_public_path__ + "img/List.3ad40483.svg";